import styled from 'styled-components';
export const StyledLoadingContainer = styled.div `
  width: 100%;
`;
